import { ACCProjectProduct, AccessLevel } from "../ACCProjectProduct";
export class FrontendACCProjectProducts {
    public accProjectProducts : ACCProjectProduct[] = [
        { key: "autoSpecs", access: "none" },
        { key: "build", access: "none" },
        { key: "cost", access: "none" },
        { key: "designCollaboration", access: "none" },
        { key: "docs", access: "none" },
        { key: "insight", access: "none" },
        { key: "modelCoordination", access: "none" },
        { key: "projectAdministration", access: "none" },
        { key: "takeoff", access: "none" }
    ].map(p => ACCProjectProduct.fromAutodeskJSON(p));

    public toJSON() {
        return this.accProjectProducts.filter(p => p.access !== "none");
    }

    public static fromJSON(jsonArray: any): FrontendACCProjectProducts
    {
        let products = new FrontendACCProjectProducts();
        if(jsonArray && jsonArray.length) {
            const productMap = new Map(jsonArray.map(p => [p.key, p.access]));
            products.accProjectProducts = products.accProjectProducts.map(defaultProduct => ({
                key: defaultProduct.key,
                access: productMap.get(defaultProduct.key) ?? "none"
            })).map(p => ACCProjectProduct.fromAutodeskJSON(p));
        }
        return products;
    }

    // public static updateJSON(products: FrontendACCProjectProducts, jsonArray: any) 
    // {
    //     if(jsonArray && jsonArray.length) {
    //         const productMap = new Map(jsonArray.map(p => [p.key, p.access]));
    //         for(const p of products.accProjectProducts) {
    //             p.access = productMap.get(p.key) as AccessLevel ?? "none";
    //         }
    //     }
    //     return products;
    // }
}